<template>
  <div>
    <customList :filterItems="formItems" :filterModel="filter"  @selectChange="selectChange" :columns="columns" :listUrl="'/admin/clientuser/list'" ref="customList">
      <template v-slot:listOperate>
        <div class="operateWrap">
          <Button type="primary" icon="md-add" @click="addUserDialog" class="operateBtn">添加</Button>
          <Button type="primary" icon="md-add" @click="batchUserModalstatus=true">批量导入</Button>
        </div>
      </template>
    </customList>

    <Modal
      :title="dialogText"
      v-model="settleModalstatus"
      :mask-closable="false"
      :width="500"
      @on-cancel="closeSettleModal"
    >
      <div>
        <CustomForm :title="''" :dataArr="createObjArr" :model="createObj" :defaultSpan="24" :labelWidth="100"/>
      </div>
      <div slot="footer">
        <Button @click="closeSettleModal">取消</Button>
        <Button type="primary" @click="submitSettle">确定</Button>
      </div>
    </Modal>
    <Modal
      title="批量添加用户"
      v-model="batchUserModalstatus"
      :mask-closable="false"
      :width="800"
      @on-cancel="batchUserModalstatus=false"
    >
      <div>
        <input id="uploadFile" type="file"  @change="fileChange" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
      </div>
      <div slot="footer">
        <Button @click="batchUserModalstatus=false">取消</Button>
        <Button type="primary" @click="batchAddUsers">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getDataFromConfig } from '../../../assets/js/share';
const createObjArr = [
  {
    label: '手机号',
    key: 'mobile',
    verify: [
      {
        required: true
      }
    ]
  },
  {
    label: '姓名',
    key: 'name',
    verify: [
      {
        required: true
      }
    ]
  },
  {
    label: '是否可用',
    key: 'delStatus',
    type: 'select',
    options: [
      { name: '可用', value: 0 },
      { name: '禁用', value: 1 }
    ]
  }
  // {
  //   label: '管理员',
  //   key: 'userType',
  //   type: 'select',
  //   options: [
  //     { name: '普通成员', value: 1 },
  //     { name: '后台管理员', value: 2 },
  //     { name: '渠道自切换', value: 3 }
  //   ]
  // },
  // {
  //   label: 'AI通道切换',
  //   key: 'checkApi',
  //   type: 'select',
  //   options: [
  //     { name: '不可切换', value: 1 },
  //     { name: '可自行切换', value: 2 }
  //   ]
  // }
];
const createObj = getDataFromConfig(createObjArr); // 通过getDataFromConfig方法推导出模型对象
console.log(createObj);
export default {
  name: 'userList',
  data () {
    return {
      dialogText: '添加用户',
      dialogUrl: '/admin/clientUser/add',
      settleModalstatus: false,
      batchUserModalstatus: false,
      file: new FormData(),
      createObj,
      createObjArr,
      formItems: [
        { label: '手机号', model: 'mobile' },
        { label: '姓名', model: 'name' },
        { type: 'select', label: '使用平台', model: 'apiType', options: [{ name: '全部', value: '' }, { name: 'minimax', value: 1 }, { name: 'OpenAI', value: 2 }, { name: 'Claude', value: 3 }, { name: '讯飞星火', value: 4 }], fun: 'selectChange' },
        { type: 'select', label: '是否可切换平台', model: 'checkApi', options: [{ name: '全部', value: '' }, { name: '不可切换', value: 1 }, { name: '可以切换', value: 2 }], fun: 'selectChange' },
        { type: 'select', label: '状态', model: 'delStatus', options: [{ name: '全部', value: '' }, { name: '可用', value: 0 }, { name: '禁用', value: 1 }], fun: 'selectChange' },
        { type: 'button', buttonArr: [{ message: '查询', type: 'primary', fun: 'selectChange' }] }
      ],
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '电话', key: 'mobile', fixed: 'left' },
        { title: '姓名', key: 'name', ellipsis: true, tooltip: true },
        {
          title: '使用平台',
          key: 'api_type',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.api_type === 1 ? 'minimax' : params.row.api_type === 2 ? 'OpenAI' : params.row.api_type === 3 ? 'Claude' : params.row.api_type === 4 ? '科大讯飞' : '')
            ]);
          }
        },
        {
          title: '可切换平台',
          key: 'check_api',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.check_api === 1 ? '否' : params.row.check_api === 2 ? '是' : '')
            ]);
          }
        },
        {
          title: '用户状态',
          key: 'del_status',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.del_status === 0 ? '可用' : params.row.del_status === 1 ? '禁用' : '')
            ]);
          }
        },
        {
          title: '创建时间',
          key: 'create_time',
          width: 150,
          render: (h, params) => {
            console.log(params.row.create_time);
            const dbDatetime = new Date(params.row.create_time);
            return h('div', [
              h('span', {}, params.row.create_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        {
          title: '更新时间',
          key: 'update_time',
          width: 150,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.update_time);
            return h('div', [
              h('span', {}, params.row.update_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        {
          title: '操作',
          key: 'groupName',
          width: 110,
          fixed: 'right',
          render: (h, params) => {
            const buttonArr = [];
            buttonArr.push(
              h(
                'Button',
                {
                  props: { type: 'info', size: 'small' },
                  on: {
                    click: () => {
                      console.log(params.row);
                      const obj = {
                        userId: params.row.user_id,
                        name: params.row.name,
                        mobile: params.row.mobile,
                        delStatus: params.row.del_status
                      };
                      this.dialogText = '修改用户';
                      this.dialogUrl = '/admin/clientUser/update';
                      this.createObj = Object.assign({}, obj);
                      this.settleModalstatus = true;
                    }
                  }
                },
                '修改信息'
              )
            );
            return h('div', { }, buttonArr);
          }
        }
      ]
    };
  },
  methods: {
    addUserDialog () {
      this.dialogText = '添加用户';
      this.settleModalstatus = true;
      this.createObj.delStatus = 0;
      this.dialogUrl = '/admin/clientUser/add';
    },
    openFile () {
      document.getElementById('uploadFile').click();
    },
    fileChange () {
      this.file = new FormData();
      this.file.append('file', document.getElementById('uploadFile').files[0]);
    },
    // 批量添加用户
    batchAddUsers () {
      const url = '/admin/clientUser/addUsers';
      this.$ajax({ method: 'post', url, data: this.file }).then(res => {
        if (res.data.status == 200) {
          this.$Message.success('添加成功');
        }
        this.batchUserModalstatus = false;
        this.$refs.customList.searchTableInfo();
      }).catch(() => {
        this.$Message.error('修改失败');
      });
    },
    selectChange () {
      alert('开始查找');
    },
    closeSettleModal () {
      this.settleModalstatus = false;
    },
    submitSettle () {
      const { name, mobile, userId, delStatus } = this.createObj;
      const params = {
        name,
        mobile,
        userId,
        delStatus
      };
      const url = this.dialogUrl;
      this.$ajax.post(url, { params }).then((data) => {
        if (data.data && data.data.status === 200) {
          this.$Message.success('操作成功');
          this.$refs.customList.searchTableInfo();
        }
        this.settleModalstatus = false;
      }).catch(() => {
        this.$Message.error('修改失败');
      });
    }
  },
  mounted () {
    this.columns.forEach((item) => {
      this.$set(item, 'align', 'center');
    });
  }
};
</script>
<style scoped>
.operateWrap {
  padding: 10px 0;
}
.operateBtn {
  margin-right: 10px;
}
.ivu-upload {
  float: none !important;
}
</style>
